import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
//Redux
import { useDispatch, useSelector } from 'react-redux'
import { updatePlatformType } from '../../redux/slices/meta'
import { RootState } from '../../redux/store'

//Helpers
import { setCookie } from '../../helpers/Cookie'
import { useQueryParam } from '../../hooks/useQueryParam'

//Types
import { DeviceTypes, PlatFormTypes, ViewTypes } from '../../types/state'

//Components
import Login from '../Login'
import Offers from '../Offers'
import Votes from '../Votes'
import TnContent from '../../components/TnC'
import { setLocation } from '../../redux/slices/user'
import Winners from '../Winners'
import Scratch from '../Scratch'

const Switch = () => {
	const dispatch = useDispatch()
	const [sessionId] = useQueryParam('session', '')
	const [platform] = useQueryParam('device', '')
	const [lat] = useQueryParam('lat', '')
	const [long] = useQueryParam('long', '')
	const metaData = useSelector((state: RootState) => state.meta)

	useEffect(() => {
		if (lat !== '' && long !== '') {
			dispatch(
				setLocation({
					latitude: +lat,
					longitude: +long,
				})
			)
		}

		if (sessionId !== '') {
			setCookie({
				name: 'frontend',
				value: sessionId,
				days: 30,
				mins: 0,
			})
		}
		if (platform !== '') {
			dispatch(
				updatePlatformType(
					platform === 'app' ? PlatFormTypes.IOS : PlatFormTypes.ANDROID
				)
			)
		} else {
			dispatch(
				updatePlatformType(
					metaData.deviceType === DeviceTypes.DESKTOP
						? PlatFormTypes.DESKTOP
						: PlatFormTypes.MWEB
				)
			)
		}
	}, [dispatch, metaData.deviceType, platform, sessionId, lat, long])

	const checkLogin =
		metaData.view === ViewTypes.LANDING ||
		metaData.view === ViewTypes.LOGIN ||
		metaData.view === ViewTypes.OTP ||
		metaData.view === ViewTypes.USER_INFO

	return (
		<>
			{checkLogin && <Login />}
			{metaData.view === ViewTypes.VOTES && <Votes />}
			{metaData.view === ViewTypes.OFFERS && <Offers />}
			{metaData.view === ViewTypes.TNC && <TnContent />}
			{metaData.view === ViewTypes.WINNERS && <Winners />}
			{metaData.view === ViewTypes.SCRATCH && <Scratch />}
			<div>
				<Toaster position="bottom-center" />
			</div>
		</>
	)
}

export default Switch
